import { applyActiveEffect, removeActiveEffect } from './combatTimeline';

export const VEX_DEFINITION_ID = 'weapon-mastery:vex';
export const VEX_ADVANTAGE_SOURCE = 'Weapon Mastery: Vex';

const combatantId = (participant) => String(participant?.characterId || participant?.enemyId || participant?.combatantId || participant?.id || '');

export const isStructuredCombat = (combatState) => Boolean(
  combatState && Number.isInteger(combatState.turnSequence) && combatState.activeTurn != null &&
  Array.isArray(combatState.participants)
);

export const getActiveVexEffect = (combatState, attackerId, targetId) => {
  if (!isStructuredCombat(combatState) || !attackerId || !targetId) return null;
  const ids = new Set(combatState.participants.map(combatantId));
  if (!ids.has(String(attackerId)) || !ids.has(String(targetId))) return null;
  return (combatState.activeEffects || []).find((effect) =>
    effect?.definitionId === VEX_DEFINITION_ID &&
    String(effect.sourceCombatantId) === String(attackerId) &&
    String(effect.targetCombatantId) === String(targetId)) || null;
};

export const isVexMasteryAttack = (attack) => Boolean(
  attack?.hasWeaponMastery &&
  String(attack?.mastery?.key || attack?.mastery?.id || attack?.mastery?.label || '').trim().toLowerCase() === 'vex'
);

export const qualifiesForVex = ({ attack, outcome, damageApplied }) =>
  isVexMasteryAttack(attack) && ['hit', 'critical-hit'].includes(outcome) && Number(damageApplied) > 0;

export const consumeVexEffect = (combatState, effectId) => effectId ? removeActiveEffect(combatState, effectId) : combatState;

/** Pure timeline operation used by the server-equivalent tests and combat reducers. */
export const applyVexEffect = (combatState, { attackerId, targetId, resolutionId }) => {
  if (!isStructuredCombat(combatState) || !attackerId || !targetId || !resolutionId) return combatState;
  return applyActiveEffect(combatState, {
    id: `vex:${resolutionId}`,
    definitionId: VEX_DEFINITION_ID,
    name: 'Weapon Mastery: Vex',
    sourceCombatantId: attackerId,
    targetCombatantId: targetId,
    stackKey: `${VEX_DEFINITION_ID}:${attackerId}:${targetId}`,
    stackPolicy: 'refresh',
    userVisible: false,
    expiration: { type: 'sourceTurn', combatantId: attackerId, boundary: 'end', remainingOccurrences: 1 },
  });
};
